import { Grid } from '@mui/material';
import { RedirectParamsDataProps } from './props';
import { useRedirectParamsData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const RedirectParamsData = (props: RedirectParamsDataProps) => {
    const { formik, areas } = useRedirectParamsData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    value={formik.values.name}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <AutocompleteField
                    data={formatParams(areas)}
                    label="Área"
                    name="parent"
                    size="small"
                    value={formik.values.parent}
                />
            </Grid>
            <Grid item xs={6}>
                <FieldText
                    label="Correo(s)"
                    name="extra"
                    size="small"
                    rows={3}
                    value={formik.values.extra}
                />
            </Grid>
            <Grid item xs={6}>
                <FieldText
                    label="Observación"
                    name="extra2"
                    size="small"
                    rows={3}
                    value={formik.values.extra2}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                />
            </Grid>
        </Grid>
    );
};
